import { useEffect, useRef, useState } from "react";
import { Body, BodyColor, BodyType, Heading, TypographyColor, TypographyType } from ".";

interface TableMenuProps {
    row: any;
    cols: any[];
    menuRef: any;
    onMenuClick: (flag?: boolean) => void;
    index: number;
    selRow: number | null;
    showTooltip?: Map<string, boolean>;
    tooltipText?: string;
    position?: 'top' | 'bottom';
}

export const TableMenu: React.FC<TableMenuProps> = ({ row, cols, menuRef, onMenuClick, index, selRow, showTooltip, tooltipText, position = 'bottom' }) => {
    const triggerRef = useRef<HTMLSpanElement>(null);
    const [tooltipAbove, setTooltipAbove] = useState(false);

    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
                onMenuClick(true);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
        if (selRow === index && triggerRef.current) {
            const rect = triggerRef.current.getBoundingClientRect();
            setTooltipAbove(window.innerHeight - rect.bottom < 120);
        }
    }, [selRow, index]);

    return (
        <>
            <span ref={triggerRef} className='material-symbols-outlined fs-18 cursor-pointer fw-bold color-black-5' onClick={() => onMenuClick()}>
                more_vert
            </span>

            {selRow === index && (
                <div ref={menuRef} className={`d-flex flex-column gap-1 position-absolute padding-4 table_menu_container ${tooltipAbove ? 'table_menu_above' : (position === 'top' ? 'table_menu_top' : '')}`}>
                    {cols.map(item => (
                        <div key={item.label} className={`d-flex align-items-center cursor-pointer gap-2 padding-2 ${showTooltip && showTooltip.get(item.id) ? 'compare' : ''}`} onClick={() => !item.isDisabled && item.onClick(row)}>
                            <span className={`material-symbols-outlined fs-20 ${item.isDisabled ? 'opacity-50 cursor-default' : ''}`}>{item.icon}</span>
                            <Body
                                type={BodyType.p2}
                                color={BodyColor.primary}
                                classname={`p-0 ${item.isDisabled ? 'opacity-50 cursor-default' : ''}`}
                            >
                                {item.label}
                            </Body>

                            {showTooltip && showTooltip.get(item.id) &&
                                <div className={`compare-tooltip position-absolute bg-white rounded ${tooltipAbove ? 'above' : 'bottom'} td`}>
                                    <Heading
                                        title={tooltipText}
                                        type={TypographyType.h6}
                                        colour={TypographyColor.secondary}
                                        classname='text-start padding-2'
                                    />
                                </div>
                            }
                        </div>
                    ))}
                </div>
            )}
        </>
    )
}
